import { Card } from "@mui/material";
import { useContext } from "react";
import ReactJson from "react-json-view";
import Scrollbar from "src/components/Scrollbar";

import DemoContext from "../../../context";

// ----------------------------------------------------------------------

export const JsonResult = () => {
	const demoContext = useContext(DemoContext);
	return (
		<Card sx={{ p: 3, maxWidth: 1000, width: "100%", mt: 3, backgroundColor: "#2B2B2B", mb: 10 }}>
			<Scrollbar>
				<ReactJson
					src={{ activePositions: demoContext.state.demoData?.activePositions ?? [] }}
					theme='railscasts'
					displayObjectSize={false}
				/>
			</Scrollbar>
		</Card>
	);
};

export default JsonResult;
